module.exports = __webpack_public_path__ + "static/media/copy_link_gray.e9cf966d.svg";